<template>

    <transition name="fade">
        <div v-if="hasMessage" :class="classes">
            <v-close v-if="canClose" :type="type" @click.native="closeAlert" />
            <div class="alert-body" v-html="payload ? payload.message : message"></div>
        </div>
        <div v-else-if="$slots['default']" :class="classes">
            <v-close v-if="canClose" :type="type" @click.native="closeAlert" />
            <div class="alert-body"><slot></slot></div>
        </div>
    </transition>

</template>

<style lang="scss">

    .alert {

        background: #fff;
        border: none;
        border-radius: 0;
        margin-bottom: 15px;
        overflow: hidden;
        padding: 0;
        position: relative;
        text-align: center;
        word-wrap: break-word;

        .alert-body {
            position: relative;
            a {
                text-decoration: underline;
            }
        }

        &.alert-sm .alert-body {
            @include font-medium(11px);
            line-height: 1.4em;
            padding: 10px 20px;
        }
        &.alert-md .alert-body {
            @include font-medium(13px);
            line-height: 1.6em;
            padding: 20px 30px;
        }

        &.alert-info {
            border: 1px solid $color-primary;
            .alert-body {
                background: none;
                color: $color-primary;
                a { color: $color-primary; }
            }
        }
        &.alert-danger .alert-body {
            background: rgba($color-danger, 0.05);
            color: $color-danger;
            a { color: $color-danger; }
        }
        &.alert-warning .alert-body {
            background: rgba($color-warning, 0.05);
            color: $color-warning;
            a { color: $color-warning; }
        }
        &.alert-success .alert-body {
            background: rgba($color-success, 0.05);
            color: $color-success;
            a { color: $color-success; }
        }

    }

</style>

<script>

export default {

    props: {
        payload: {
            type: Object,
            default: null,
        },
        message: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'danger',
        },
        size: {
            type: String,
            default: 'md',
        },
        canClose: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        hasMessage() {
            return this.payload ? this.payload.message : this.message;
        },

        classes() {
            let type = this.payload ? this.payload.type : this.type;
            return {
                'alert': true,
                'alert-info': type === 'info',
                'alert-danger': type === 'danger',
                'alert-warning': type === 'warning',
                'alert-success': type === 'success',
                'alert-sm': this.size === 'sm',
                'alert-md': this.size === 'md',
            };
        },

    },

    methods: {

        closeAlert() {
            this.$el.parentNode.removeChild(this.$el);
        }

    },

}

</script>
